import { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import {
  Container,
  Box,
  Typography,
  Stack,
  Button,
  Checkbox,
} from "@mui/material";

import { useAnalytics } from "../../context/AnalyticsProvider";
import { ANALYTICS_TAGS } from "../../constants/analyticsTags";
import ActionButton from "../account/ActionButton";
import ArrangementForm from "./ArrangementForm";
import ArrangementInfoCard from "./ArrangementInfoCard";


/**
 * Arrangement setup component
 * */
function ArrangementSetup({ handleNext }) {

  const [ planConsent, setPlanConsent ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState(null);
  const [ validArrangement, setValidArrangement ] = useState(false);

  const { setTag } = useAnalytics();
  const location = useLocation()

    function toggleConsent() {
    if (!planConsent && !validArrangement) {
      setErrorMessage("Please select a valid arrangement.");
    } else {
      setPlanConsent(!planConsent);
      setTag(ANALYTICS_TAGS.REPAYMENT_METHOD, { path: location.pathname, planConsent: planConsent });
    }
  }

  return (
    <>
      <Typography component='label' htmlFor='email' sx={{ fontWeight: "bold" }}>
          Create your repayment plan
      </Typography>
      <Stack
        sx={{
          mt: 2,
        }}
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
      >        
        <Box sx={{ width: { xs: "100%", md: "70%" } }}>
          {/* Left column */}
          <ArrangementForm
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            setValidArrangement={setValidArrangement}
          />
          {/* End of left column */}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "30%" } }}>
          {/* Right column */}
          <ArrangementInfoCard />

          {/* Affordability confirmation */}
          <Box id='declaration' sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                id='declaration-checkbox'
                checked={planConsent}
                onChange={() => {toggleConsent();}}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Box>
            <Box sx={{ p: 0.5 }}>
              <Typography
                id='declaration-statement'
                component='h2'
                variant='p'
                sx={{ display: "inline-block", mt: 2, fontSize: 16 }}
              >
                I confirm that the repayment plan is affordable for me, based 
                on my current financial commitments.
              </Typography>
            </Box>
          </Box>
          {/* End of affordability confirmation */}

          {/* Call To Action */}
          <Box sx={{ textAlign: "center", pt: 2, pb: 4 }}>
            <Container sx={{ pb: 2 }}>
              <Button
                id='continue-btn'
                onClick={handleNext}
                variant='contained'
                disabled={!planConsent}
                sx={{
                  textTransform: "none",
                  borderRadius: 0,
                  width: { xs: "5em", lg: "20em" },
                  backgroundColor: "primary.dark",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.light",
                    color: "primary.dark",
                  },
                }}
              >
                Continue
              </Button>
            </Container>

            <Container>
              <ActionButton
                id='change-btn'
                buttonColor='#FFF'
                buttonTextColor='secondary.main'
                buttonTitle='Change Financial Statement'
                outlined='true'
                hoverColor='secondary.main'
                hoverTextColor='#FFF'
                target='/sfs'
              />
            </Container>
          </Box>

          {/* End of right column */}
        </Box>
      </Stack>
    </>
  );
};

ArrangementSetup.propTypes = {
  handleNext: PropTypes.func,
};

export default ArrangementSetup;
